var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-calc-footer" }, [
      _c("div", { staticClass: "c-calc-footer__inner" }, [
        _c("img", {
          staticClass: "c-calc-footer__lightblulb",
          attrs: {
            src: "_resources/app/client/assets/images/lightbulp-grey.svg",
            alt: "lightbulp icon",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "logo" }, [
          _c("a", { attrs: { href: "/" } }, [
            _c("img", {
              attrs: {
                src: "_resources/app/client/assets/images/we-logo.svg",
                alt: "Wellington Electricity",
                title: "Wellington Electricity",
                width: "179",
                height: "48",
              },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }